export const PUBLISH_STATUS = [
  { id: 'not-published', name: 'Not Published' },
  { id: 'published-all', name: 'Published - All' },
  { id: 'published-active', name: 'Published - Active' },
  { id: 'published-expired', name: 'Published - Expired' },
];
